// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/group.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ListGroupsRequest, ListGroupsResponse } from "./group_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.GroupService
 */
export const GroupService = {
  typeName: "gitpod.v1.GroupService",
  methods: {
    /**
     * Lists groups with optional pagination.
     *
     * Use this method to:
     * - View all groups
     * - Check group memberships
     * - Monitor group configurations
     * - Audit group access
     *
     * ### Examples
     *
     * - List all groups:
     *
     *   Shows all groups with pagination.
     *
     *   ```yaml
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * - List with custom page size:
     *
     *   Shows groups with specified page size.
     *
     *   ```yaml
     *   pagination:
     *     pageSize: 50
     *     token: "next-page-token-from-previous-response"
     *   ```
     *
     * @generated from rpc gitpod.v1.GroupService.ListGroups
     */
    listGroups: {
      name: "ListGroups",
      I: ListGroupsRequest,
      O: ListGroupsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
  }
} as const;

